export default __webpack_public_path__ + "static/media/success.52ce363f.svg";